<template>
	<headless-modal ref="marketModalRef" id="market" title="Select your country" @closed="handleClosed">
		<template v-slot:content>
			<ul v-if="marketChangeAllowed" class="p-0 flex flex-col gap-4">
				<li v-for="market of marketRegistry" :key="market.market_key">
					<a :href="handleMarketRoute(market)" class="flex flex-col gap-2 items-center justify-center">
						<span>
							<svg-vue
								:icon="marketIcons[market.market_key] ?? marketIcons['generic']"
								class="w-full max-w-16 max-h-16 h-auto flex-shrink-0 overflow-visible"
							/>
						</span>
						<span>{{ market.name }}</span>
					</a>
				</li>
			</ul>
			<p v-else class="!text-black font-normal text-base text-center">
				The market cannot be changed {{ isCheckout ? 'during checkout' : 'on the order confirmation page' }}.
			</p>
		</template>
		<template v-slot:button>
			<button type="button" class="flex items-center gap-2" @click="handleMarketModalOpen">
				<svg-vue :icon="marketIcons[currentMarketKey] ?? marketIcons['generic']" class="w-4 h-4" />
				<span class="text-xs font-normal text-stone-500">
					{{ marketDisplay[currentMarketKey] ?? marketDisplay['generic'] }}
				</span>
			</button>
		</template>
	</headless-modal>
</template>
<script setup>
import { ref, watch, computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useAppStore } from '@stores'

const props = defineProps({
	isCheckout: {
		type: Boolean,
		default: false,
	},
	isConfirmation: {
		type: Boolean,
		default: false,
	},
	currentMarketKey: {
		required: true,
		type: String,
		default: 'generic',
	},
	currentMarketName: {
		required: true,
	},
	marketRegistry: {
		required: true,
	},
})

const appStore = useAppStore()
const { marketModal } = storeToRefs(appStore)
const { closeMarketModal } = appStore

const marketModalRef = ref(null)

watch(marketModal, (openModal) => {
	if (openModal) {
		marketModalRef.value.setIsOpen(true)
	}
})

const marketIcons = ref({
	US: 'circle-flag-usa',
	CA: 'circle-flag-canada',
	GB: 'circle-flag-uk',
	UK: 'circle-flag-uk',
	generic: 'location-pin',
})
const marketDisplay = ref({
	US: 'US',
	CA: 'CA',
	GB: 'UK',
	UK: 'UK',
	generic: 'N/A',
})

const marketChangeAllowed = computed(() => !props.isCheckout && !props.isConfirmation)

const handleMarketModalOpen = () => marketModalRef.value.setIsOpen(true)
const handleClosed = () => closeMarketModal()
const handleMarketRoute = (market) => {
	const base = `${window.document.location.origin}${window.document.location.pathname}`
	const isoCode = `?isoCode=${market.market_key}`
	return `${base}${isoCode}`
}
</script>
